invHdApp.factory('Filter', ['$http', function ($http) {
    return {
        getCustomers: function () {
            return $http.get('api/filter/customers', {
                ignoreLoadingBar: true
            });
        },
        getCompanies: function () {
            return $http.get('api/filter/companies', {
                ignoreLoadingBar: true
            });
        },
        getWorkers: function () {
            return $http.get('api/filter/workers', {
                ignoreLoadingBar: true
            });
        },
        getStations: function () {
            return $http.get('api/filter/stations', {
                ignoreLoadingBar: true
            });
        },
        getCities: function () {
            return $http.get('api/filter/cities', {
                ignoreLoadingBar: true
            });
        }
    };
}]);